import Auth from "@aws-amplify/auth";
import { API, graphqlOperation } from "aws-amplify";
import { sendConfirmationCodeLf, setPasswordLf } from "graphql/queries";
import { Response } from "types/graphqlapi";

export const DEFAULT_PASSWORD = "password";

export const signUp = async (email: string) => {
  return await Auth.signUp({
    username: email,
    password: DEFAULT_PASSWORD,
    attributes: {
      email,
    },
  });
};

export const confirmSignUp = async (email: string, code: string) => {
  return await Auth.confirmSignUp(email, code);
};

export const resendSignUp = async (email: string) => {
  return await Auth.resendSignUp(email);
};

export const signIn = async (email: string, password: string) => {
  return await Auth.signIn(email, password);
};

export const changePassword = async (newpassword: string) => {
  const user = await Auth.currentAuthenticatedUser();
  return await Auth.changePassword(user, DEFAULT_PASSWORD, newpassword);
};

export const forgotPasswordSubmit = async (
  email: string,
  code: string,
  newPassword: string
) => {
  return await Auth.forgotPasswordSubmit(email, code, newPassword);
};

export const forgotPassword = async (email: string) => {
  return await Auth.forgotPassword(email);
};

export const updatePassword = async (
  oldpassword: string,
  newpassword: string
) => {
  const user = await Auth.currentAuthenticatedUser();
  return await Auth.changePassword(user, oldpassword, newpassword);
};

export const signOut = async () => {
  return await Auth.signOut();
};

export const sendConfirmationCode = async (email: string) => {
  try {
    const result = (await API.graphql(
      graphqlOperation(sendConfirmationCodeLf, {
        email: email,
      })
    )) as {
      data: { sendConfirmationCodeLf: Response };
    };
    if (!result.data.sendConfirmationCodeLf.body)
      throw new Error("sendConfirmationCode error");
    const resultJson = JSON.parse(result.data.sendConfirmationCodeLf.body);

    if (resultJson.result === "Succeeded") return "Succeeded";

    return resultJson.error;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const setPassword = async (
  email: string,
  password: string,
  confirmation_code: string
) => {
  try {
    const result = (await API.graphql(
      graphqlOperation(setPasswordLf, {
        email: email,
        password: password,
        confirmation_code: confirmation_code,
      })
    )) as {
      data: { setPasswordLf: Response };
    };
    if (!result.data.setPasswordLf.body) throw new Error("setPasswordLf error");
    const resultJson = JSON.parse(result.data.setPasswordLf.body);

    if (resultJson.result === "Succeeded") return resultJson.name;
    return resultJson.error;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
